if (!customElements.get("gift-note-handler")) {
  class GiftNoteHandler extends HTMLElement {
    constructor() {
      super();
      this.textAreaLimit = this.dataset.giftNoteLimit;
      this.giftVariant = parseInt(this.dataset.giftVariant);
      this.product = parseInt(this.dataset.product);
      this.giftNoteAttribute = this.dataset.giftNoteAttribute;
      this.commitOn = this.dataset.commitOn; // "live" or "save" - the former commits changes live as the user edits the form, the latter commits with a button

      // DOM elements
      this.field = this.querySelector(`[name="attributes[${this.giftNoteAttribute}]"]`);
      this.limitCounter = this.querySelector("[data-gift-limit-counter]");
      this.details = this.querySelector("[data-gift-note-details]");
      this.allDetails = [...document.querySelectorAll("details[data-collapsible]")];
      this.giftCheckbox = this.querySelector("[data-enable-gift]");

      this.field.addEventListener("input", this.updateTextAreaLimitText.bind(this));
      this.field.addEventListener("input", () => {
        if (this.commitOn === "live") this.updateOtherGiftNoteFields();
        if (this.commitOn === "save" && this.getGiftInCart()) this.updateOtherGiftNoteFields();
      });

      this.isGiftCheckboxChecked = false;

      document.addEventListener("theme:gwp:cartupdate", (e) => {
        setTimeout(() => {
          // Remove the gift note if it's the only thing in cart
          if (
            this.getGiftInCart() &&
            [...document.querySelectorAll("[data-merge-list-item]:not(.merge-remove-item) .cart-item")].length === 1
          ) {
            this.removeGiftFromCart();
          }
        }, 0);
      });

      if (this.commitOn === "live") {
        this.initCommitOnLive();
      } else {
        this.initCommitOnSave();
      }

      document.body.addEventListener("gift-note-added", (e) => {
        const note = e.detail;
        if (note) this.field.value = note;
        this.giftCheckbox.classList.add("checked");
        this.isGiftCheckboxChecked = true;
        // this.details.setAttribute("open", "true");
        // this.details.querySelector(".cart__widget__content").style.height = "auto";
      });

      document.body.addEventListener("gift-note-removed", (e) => {
        // if (this.commitOn === "save") this.style.display = "block";
      });

      this.updateTextAreaLimitText({ target: this.field });

      if (this.getGiftInCart()) {
        // this.allDetails.forEach((d) => (d.open = false));
        // this.details.setAttribute("open", "true");
        // this.details.querySelector(".cart__widget__content").style.height = "auto";
        this.isGiftCheckboxChecked = true;
        this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
      }
    }

    initCommitOnLive() {
      this.processChange = this.debounce((e) => this.updateGiftNoteAttribute(e.target.value));
      this.field.addEventListener("input", this.processChange.bind(this));

      this.details.addEventListener("toggle", (e) => {
        // const isOpen = e.target.open;
        // if (!this.isGiftCheckboxChecked && isOpen) {
        //   this.isGiftCheckboxChecked = true;
        //   this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
        //   this.addGiftToCart();
        // }
      });

      this.giftCheckbox.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (!this.isGiftCheckboxChecked) {
          this.addGiftToCart();
          this.isGiftCheckboxChecked = true;
          // this.allDetails.forEach((d) => (d.open = false));
          this.details.setAttribute("open", "true");
          // this.details.querySelector(".cart__widget__content").style.height = "auto";
        } else {
          // this.details.open = false;
          this.isGiftCheckboxChecked = false;
          this.removeGiftFromCart();
          this.details.removeAttribute("open");
        }
        this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
      });
    }

    initCommitOnSave() {
      // if (!this.field.value.length) this.giftCheckbox.style.pointerEvents = "none";
      // if (this.getGiftInCart()) this.style.display = "none";
      document.addEventListener("theme:gwp:cartupdate", (e) => {
        if (!this.isGiftCheckboxChecked) {
          this.field.value = "";
          this.updateTextAreaLimitText({ target: this.field });
        }
        if (!this.commitOn === "save" || this.getGiftInCart() || !this.isGiftCheckboxChecked) return;
        this.addGiftToCart(this.field.value);
      });

      this.field.addEventListener("input", () => {
        this.processChange = this.debounce(() => this.updateGiftNoteAttribute(this.field.value));
        if (this.getGiftInCart()) this.processChange();
      });

      this.details.addEventListener("toggle", (e) => {
        const isOpen = e.target.open;
        // if (!this.isGiftCheckboxChecked && isOpen) {
        // this.isGiftCheckboxChecked = true;
        // this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
        // }
        if (isOpen) {
          // this.giftCheckbox.style.pointerEvents = "all";
          this.details.setAttribute("open", "true");
          this.details.querySelector(".cart__widget__content").style.height = "auto";
        } else {
          // if (!this.field.value.length) this.giftCheckbox.style.pointerEvents = "none";
          // if (!this.getGiftInCart()) {
          // if (!this.field.value) {
          // this.updateTextAreaLimitText({ target: this.field });
          // this.isGiftCheckboxChecked = false;
          // }
          // this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
          // }
        }
      });

      this.giftCheckbox.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (!this.isGiftCheckboxChecked) {
          this.isGiftCheckboxChecked = true;
          this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
          this.details.setAttribute("open", "true");
          if (this.isThereAProductInCart()) {
            this.addGiftToCart();
          }
        } else {
          this.isGiftCheckboxChecked = false;
          this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
          this.removeGiftFromCart();
          this.details.removeAttribute("open");
          this.field.value = "";
        }

        // if (this.details.open || this.field.value.length) {
        //   this.isGiftCheckboxChecked = false;
        //   this.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
        //   this.field.value = "";
        //   this.updateTextAreaLimitText({ target: this.field });
        //   this.details.setAttribute("open", "false");
        // } else {
        // this.details.setAttribute("open", "true");
        //   // this.details.querySelector(".cart__widget__content").style.height = "auto";
        // }
      });
    }

    getGiftInCart() {
      const lineItems = [...document.querySelectorAll(".cart-item")];
      const lineItem = lineItems.find((item) => {
        return parseInt(item.dataset.variant) === this.giftVariant;
      });
      return lineItem;
    }

    isThereAProductInCart() {
      const lineItems = [...document.querySelectorAll(".cart-item")];
      return lineItems.length > 0;
    }

    updateOtherGiftNoteFields() {
      const enteredGiftNote = this.field.value;
      const allGiftNoteInputs = [...document.querySelectorAll(`[name="attributes[${this.giftNoteAttribute}]"]`)];
      const allGiftNoteHandlers = [...document.querySelectorAll("gift-note-handler")];
      allGiftNoteInputs.forEach((input) => {
        input.value = enteredGiftNote;
      });
      allGiftNoteHandlers.forEach((handler) => {
        handler.isGiftCheckboxChecked = this.isGiftCheckboxChecked;
        handler.giftCheckbox.classList.toggle("checked", this.isGiftCheckboxChecked);
        handler.updateTextAreaLimitText({ target: handler.field });
      });
    }

    debounce(func, timeout = 500) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, timeout);
      };
    }

    updateTextAreaLimitText(e) {
      if (!this.textAreaLimit || !this.textAreaLimit.length) return;

      const currentText = e.target.value;
      const giftNotePreview = this.querySelector("[data-gift-note-preview]");
      if (giftNotePreview) {
        if (currentText.length) {
          giftNotePreview.innerHTML = `
        <div class="group-open:tw-hidden tw-block tw-pt-3">
          <div class="tw-flex tw-flex-row tw-justify-between">
            <p class="tw-font-semibold">Message preview</p>
            <p class="tw-underline tw-font-semibold">Edit</p>
          </div>
          <p>${currentText}</p>

        </div>`;
        } else {
          giftNotePreview.innerHTML = "";
        }
      }
      const truncatedText = currentText.slice(0, this.textAreaLimit);
      e.target.value = truncatedText; // Cut off any text beyond the limit
      const remainingChars = this.textAreaLimit - truncatedText.length;
      if (this.limitCounter) this.limitCounter.innerText = remainingChars;
      this.limitCounter.parentElement.classList.toggle("error", truncatedText.length === parseInt(this.textAreaLimit));
      const limitError = this.querySelector("[data-gift-limit-error]");
      if (limitError)
        limitError.style.display = truncatedText.length === parseInt(this.textAreaLimit) ? "inline" : "none";
    }

    async addGiftToCart(note) {
      if (this.getGiftInCart()) return;

      const itemsToAdd = [
        {
          id: this.giftVariant,
          quantity: 1,
          properties: note
            ? {
                "Gift Note": note,
              }
            : { "Gift Note": "" },
        },
      ];
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd }),
      });
      const cartChangeEvent = new CustomEvent("on:cart:change");
      document.dispatchEvent(cartChangeEvent);
      const giftNoteAddedEvent = new CustomEvent("gift-note-added", { detail: note || false });
      document.body.dispatchEvent(giftNoteAddedEvent);
      this.updateOtherGiftNoteFields();
      if (note) {
        await this.updateGiftNoteAttribute(note, true);
      }
    }

    async removeGiftFromCart() {
      this.isGiftCheckboxChecked = false;
      const lineItem = this.getGiftInCart();
      if (!lineItem) return;
      const lineItemId = lineItem.dataset.item;
      let updates = { [lineItemId]: 0 };
      const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates,
          attributes: {
            [this.giftNoteAttribute]: "",
          },
        }),
      });
      this.field.value = "";
      this.updateTextAreaLimitText({ target: this.field });
      this.updateOtherGiftNoteFields();
      const cartChangeEvent = new CustomEvent("on:cart:change");
      document.dispatchEvent(cartChangeEvent);
      const giftNoteRemovedEvent = new CustomEvent("gift-note-removed");
      document.body.dispatchEvent(giftNoteRemovedEvent);
    }

    async updateGiftNoteAttribute(value, bypassCartItem) {
      // if (!window.cart) return;
      this.updateOtherGiftNoteFields();
      const lineItem = this.getGiftInCart();
      if (!lineItem && !bypassCartItem) return;

      const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            [this.giftNoteAttribute]: value,
          },
        }),
      });
      const data = await res.json();
      if (!bypassCartItem) {
        const lineItemId = lineItem.dataset.item;
        const index = lineItem.dataset.itemIndex;
        const changeRes = await fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            line: index,
            properties: {
              "Gift Note": value,
            },
          }),
        });
        const changeData = await changeRes.json();
      }
    }
  }

  customElements.define("gift-note-handler", GiftNoteHandler);
}
